import React, {Component} from 'react';
import {Api} from '../../api';
import {encodeString, getAuthToken, setAuthData} from '../../utils';
import TextFieldInput from '../Common/TextFieldInput'
import ButtonInput from '../Common/ButtonInput'
import {Redirect} from 'react-router-dom';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import {IconButton, InputAdornment} from '@material-ui/core';
import {withRouter} from 'react-router';
import Loader from '../Common/Loader'
import {usersActions} from '../../redux/actions';
import {connect} from 'react-redux';

import './Signin.scss';

const fakeInputStyle = {opacity: 0, float: 'left', border: 'none', height: '0', width: '0'}; //fix for browser autofill

class Signin extends Component {

    state = {
        username: '',
        password: '',
        showPassword: false,
        errors: {
            username: false,
            password: false,
            common: false
        },
        isLoading: false
    };

    render() {
        const {username, password, showPassword, errors, isLoading} = this.state;

        if (getAuthToken()) {
            return <Redirect to="/user"/>;
        }

        return (
            <div className={'signin-popup'}>
                {isLoading && <Loader/>}
                <form className={`signin-popup__form`}>
                    <div className={'form-wrapper'}>
                        <header className="signin-popup__header">
                            <div className={'content-logo'}>
                                <div className={'ts-logo-rectangle'}>
                                    <div className={'ts-logo'}>
                                        <div className={'symbol-t-logo'}>
                                            <svg width="47" height="38" viewBox="0 0 47 38" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M33.627 0.120605H46.0957V15.8457H42.9785C40.9375 15.8457 39.4346 15.6323 38.4697 15.2056C37.5049 14.7603 36.7441 14.2686 36.1875 13.7305C35.6494 13.1738 35.1855 12.4502 34.7959 11.5596C34.0166 9.74121 33.627 7.21777 33.627 3.98926V0.120605ZM15.6196 0.120605H30.5933V38H15.6196V0.120605ZM0.0336914 0.120605H12.5024V3.98926C12.5024 8.75781 11.6396 12.0049 9.91406 13.7305C8.50391 15.1406 6.24951 15.8457 3.15088 15.8457H0.0336914V0.120605Z"
                                                    fill="#1B5DAA"/>
                                            </svg>
                                        </div>
                                        <div className={'symbol-s-logo'}>
                                            <svg width="37" height="38" viewBox="0 0 37 38" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M18.9316 0.120605H36.104V19.1855L18.9316 0.120605ZM0.757324 11.3091H0.590332C0.590332 7.48682 1.62939 4.6665 3.70752 2.84814C5.78564 1.02979 8.98633 0.120605 13.3096 0.120605L36.104 27.7856C36.104 31.4595 35.1113 34.085 33.126 35.6621C31.1963 37.2021 28.042 37.9722 23.6631 37.9722L0.757324 11.3091ZM0.673828 18.8237L17.2061 38H0.673828V18.8237Z"
                                                    fill="#1B5DAA"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div className={'logo-label'}>
                                    <p>
                                        TransferSign
                                    </p>
                                </div>
                                <div className={'logo-text'}>
                                    <p>
                                        Prove your services and pay net VAT,
                                        income tax or capital gains tax
                                        on cryptocurrency transactions
                                    </p>
                                </div>
                            </div>
                        </header>
                        <div className="signin-popup__body">
                            <input type="password" name='fake-password' autoComplete='new-password' tabIndex='-1'
                                   style={fakeInputStyle}/>
                            {errors.common ?
                                <div className='common-error-block'>
                                    <div className="title">{errors.common.error_description}</div>
                                    <div className="body">{errors.common.message}</div>
                                </div> :
                                <div className='sign-in-tips'>Use your credential to sign in</div>}
                            <div className="fields-row">
                                <TextFieldInput name='username'
                                                label='Email or Username'
                                                value={username}
                                                required={true}
                                                error={errors.username || errors.common}
                                                classes='width-400'
                                                handleChange={(e) => this.handleChange(e)}/>
                            </div>
                            <div className="fields-row">
                                <TextFieldInput name='password'
                                                label='Password'
                                                type={showPassword ? 'text' : 'password'}
                                                classes='width-400 p-r-0'
                                                value={password}
                                                error={errors.password || errors.common}
                                                required={true}
                                                endAdornment={{
                                                    endAdornment: (
                                                        <InputAdornment position="end" classes={{
                                                            root: 'root-input-adornment'
                                                        }}>
                                                            <IconButton
                                                                aria-label="Toggle password visibility"
                                                                onClick={() => this.setState({showPassword: !showPassword})}
                                                                onMouseDown={this.handleMouseDownPassword}
                                                            >
                                                                {showPassword ? <VisibilityOff/> :
                                                                    <Visibility/>}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                                handleChange={(e) => this.handleChange(e)}/>
                            </div>
                            <div className="fields-row">
                            <span className='password-link'
                                  onClick={() => this.props.history.push('/password_recovery')}>Forgot password?</span>
                            </div>
                            <div className="fields-row">
                                <ButtonInput
                                    className={`blue-button width-400 ${(username.length < 4 || password.length < 8) && 'disabled'}`}
                                    title='Sign In'
                                    handleClick={(e) => this.onSubmit(e)}/>
                            </div>
                            <div className="fields-row">
                                Don't have an account? <span onClick={() => this.props.history.push('/signup')}
                                                             className='m-l-20 password-link'>Sign Up</span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }

    handleChange = event => {
        let errors = this.state.errors;
        errors[event.target.name] = false;
        errors.common = false;

        this.setState({
            [event.target.name]: event.target.value,
            errors
        });
    };

    onSubmit = (e) => {
        e.preventDefault();

        if (this.formValidate()) {
            this.setState({isLoading: true})
            Api.postFormData('oauth/token', {
                username: this.state.username,
                password: this.state.password,
                grant_type: 'password',
            }).then((response) => {

                setAuthData([response.data.access_token, this.state.username, response.data.user_id, encodeString(response.data.role)]);

                const {dispatch} = this.props;
                dispatch(usersActions.permissions(response.data.permissions));
                this.props.history.push('/user');

            }).catch((error) => {
                console.log(error, 'error')
                if (error.response.data) {
                    this.setState({isLoading: false})
                    let errors = this.state.errors;
                    errors.common = error.response.data;
                    this.setState({errors})
                }
            })
        }
    };

    handleMouseDownPassword = event => {
        event.preventDefault();
    };

    formValidate = () => {
        const {username, password, errors} = this.state;
        let isValid = true;
        errors.common = false;

        if (!username) {
            errors.username = 'The username field is required';
            this.setState({errors});
            isValid = false;
        } else if (username.length < 4) {
            errors.username = 'Username should be at least 4 characters;';
            this.setState({errors});
            isValid = false;
        } else {
            errors.username = false;
            this.setState({errors});
        }

        if (!password) {
            errors.password = 'The password field is required';
            this.setState({errors});
            isValid = false;
        } else if (password.length < 8) {
            errors.password = 'Hint: your password is at least 8 symbols long';
            this.setState({errors});
            isValid = false;
        } else {
            errors.password = false;
            this.setState({errors});
        }

        return isValid;
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(withRouter(Signin));


// WEBPACK FOOTER //
// ./src/components/Signin/Signin.js